/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BigWheel.vue?vue&type=template&id=7d9f9e50&scoped=true"
import script from "./BigWheel.vue?vue&type=script&lang=js"
export * from "./BigWheel.vue?vue&type=script&lang=js"
import style0 from "./BigWheel.vue?vue&type=style&index=0&id=7d9f9e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9f9e50",
  null
  
)

export default component.exports